import type { DemoId } from "app/pages/sales-intelligence/types/demo-mode";

import { INDUSTRY_TAXONOMY_DEMO_ID } from "../constants";

type IndustryVisibilityInput = {
    readonly activeDemoId?: DemoId;
    readonly isIndustryTaxonomyOptedIn: boolean;
};

export const showsIndustryTaxonomy = ({ activeDemoId, isIndustryTaxonomyOptedIn }: IndustryVisibilityInput): boolean =>
    isIndustryTaxonomyOptedIn || activeDemoId === INDUSTRY_TAXONOMY_DEMO_ID;

export const showsLegacyIndustry = (input: IndustryVisibilityInput): boolean => !showsIndustryTaxonomy(input);
